export class User {
  public id: string;
  public userName: string;
  public isLocal: boolean;
  public isOwner: boolean;

  public audioTrack: MediaStreamTrack | null = null;
  public videoTrack: MediaStreamTrack | null = null;

  public hasReceivedInitialState = false;
  public joinedAt = new Date();

  constructor(userId: string, userName: string, isLocal: boolean, isOwner: boolean, audioTrack?: MediaStreamTrack, videoTrack?: MediaStreamTrack) {
    this.id = userId;
    this.userName = userName;
    this.isLocal = isLocal;
    this.isOwner = isOwner;

    if (audioTrack) this.audioTrack = audioTrack;
    if (videoTrack) this.videoTrack = videoTrack;
  }

  // constructor(userId: string, userName: string, isLocal: boolean, audioTrack?: MediaStreamTrack, videoTrack?: MediaStreamTrack) {
  //   this.id = userId;
  //   this.userName = userName;
  //   this.isLocal = isLocal;

  //   if (audioTrack) this.audioTrack = audioTrack;
  //   if (videoTrack) this.videoTrack = videoTrack;
  // }
}

export const NOT_CONNECTED_USER: User = {
  id: 'localUserId',
  userName: 'userName',
  isLocal: true,
  isOwner: false,
  audioTrack: null,
  videoTrack: null,
  hasReceivedInitialState: false,
  joinedAt: new Date(),
}

/* DailyParticipant
  // track state
  tracks: DailyParticipantTracks & {
    [customTrackKey: string]: DailyTrackState | undefined;
      tracks.audio.persistentTrack
      tracks.video.persistentTrack
      tracks.screenVideo.persistentTrack
  };

  // user/session info
  user_id: string;
  user_name: string;
  userData?: unknown;
  session_id: string;
  joined_at?: Date;
  will_eject_at: Date;
  local: boolean;
  owner: boolean;
  permissions: DailyParticipantPermissions;
  record: boolean;
  participantType?: string;

  DailyParticipantsObject
    local: DailyParticipant;
    [id: string]: DailyParticipant;
*/
